const C = require("../constants");

const recipeDialog = (data) => {
    return {
        type: C.RECIPE_DIALOG,
        data
    }
};

export {recipeDialog};


// WEBPACK FOOTER //
// ./src/actions/RecipeDialogActions.js